<template>
    <div class="p-4 max-w-main bg-vmain" style="min-height: calc(100vh - 62px);">
       <img @click="$router.push('/')" class="cursor-pointer" src="@/assets/default_main/logo1.svg" />
       <div class="text-center mt-2 divide-y">
            <div class=" py-3">
                <img class="m-auto" src="@/assets/default/check.svg" />
                <div class="font-bold mt-2" >
                    Cảm ơn bạn đã để lại thông tin
                </div>
                <div class="text-sm">
                    Đối tác giải ngân của Vclick sẽ liên hệ hỗ trợ bạn
                </div>
                <div class="text-sm">
                    trong vòng 24h tới, thời gian liên hệ từ 
                </div>
                <div class="font-bold text-sm">
                    8h - 17h. 
                </div>
                <div class="mt-2 text-sm">
                    Bạn vui lòng gọi hotline <strong>1900633337</strong> nếu cần hỗ trợ
                </div>
                <div class="border-gray-200 border-2 p-2 rounded-lg mt-3 w-48 m-auto">
                    <button @click="$router.push('/')" class="font-bold" > Về trang chủ</button>
                </div>
            </div>
            <div class="py-3">
                <div class=" rounded-lg text-center color-bold-vmain  mb-11">
                    <div class="mt-3 text-center">
                        <div class=" font-bold m-auto text-lg">
                            Bạn có thể nhận tư vấn gói vay nhanh qua đăng ký xe máy
                        </div>
                        <img class="m-auto mt-3" style="width: 40%;" src="@/assets/default_main/truemoney.png">
                    </div>
                    <div class="mt-3">
                        <div class=" text-left rounded-md text-base" style="font-family: Arial;">
                            <!-- Chọn hình thức vay: -->
                        
                            <ul>
                                <li v-for="item in List" :key="item.type">
                                    <div class="grid grid-cols-9">
                                        <div ><img style="width: 16px;" src="@/assets/default_main/v.png"></div>
                                        <div class="col-span-8">{{ item.type_name }}</div>
                                    </div>
                                    
                                </li>
                            </ul>
                        </div>
                        
                        <!-- <select v-model="type" class="w-full shadow-input focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent rounded-sm p-1 mt-1" name="cars" id="cars">
                            <option v-for="item in option" :key="item.type" :value="item.type">{{item.type_name}}</option>
                        
                        </select> -->
                    </div>

                    <div class="mt-4 text-center">
                        <div class=" text-left text-base font-semibold mt-3">
                            Vui lòng chọn loại phương tiện
                        </div>

                        <div v-for="(item,index) in options" class="flex items-center py-1">
                           
                            <div class="flex-initial items-center leading-8 ml-1">
                                <label >{{ index + 1 }}. {{ item.type_name }} </label>
                            </div>
                            <div class="flex-auto justify-end items-center leading-8 text-right">
                                <input class="text-right" type="radio"  :value="item.type" v-model="type">
                            </div>
                        </div>

                        <!-- <div class="flex items-center py-1">
                           
                            <div class="flex-initial items-center leading-8  ml-1">
                                <label  >2. Xe máy/ Ô tô</label>
                            </div>
                            <div class="flex-auto justify-end items-center leading-8 text-right">
                                <input class="text-right" type="radio"   value="9" v-model="type">
                            </div>
                        </div> -->
                        <div class="grid grid-cols-3 gap-4">
                            
                            <div class="col-span-3">
                                <button @click="register" class="bg-color-vmain text-white font-bold text-center w-full p-2 rounded-md shadow-lg"> Đăng ký vay True Money </button>
                            </div>
                        </div>
                        <!-- <button @click="register" class="bg-main text-white font-bold rounded-md m-auto" style="box-shadow: 4px 3px 5px rgba(100, 21, 95, 0.34); height: 31px; width: 261px;"> Nhận tư vấn ngay </button>

                        <div @click="toHomePage" class="mt-3 color-main2 font-bold">
                            Bỏ qua
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
   </template>
   
   <script>
   import {getPartner,getMoney,getLogo,getToken} from '@/utils/auth'
   import {registerTima,getTimaType} from '@/api/otp'
   import ListPartner from './components/listPartner.vue'
   import EkycInfor from './components/ekycInfo.vue'
   import router from "@/router";
   import { toDMY,toYMD,toYMDHMS } from "@/filters/index"
   import { getPhone} from '@/utils/auth'

   export default {
     components: { ListPartner,EkycInfor },
       data() {
           return {
            type: 0,
            options: [
            ],
            List: [
                {
                    type: 1,
                    type_name: 'Dễ dàng nhận khoản vay lên tới 30 triệu'
                },
                {
                    type: 2,
                    type_name: 'Giải ngân nhanh chóng trong vòng 20 phút'
                },
                {
                    type: 3,
                    type_name: 'Lãi suất thấp, chỉ 1%/tháng'
                },
            ],
           }
       },
       methods: {
        register(){
            // let type_name = 'Không có phương tiện';
            // if(this.type == 9){
            //     type_name = 'Xe máy/ ô tô';
            // }
            registerTima({type: this.type}).then(res => {
                this.$bvModal.hide('modal-tima')

                if(res.status == 200 || res.status ==0){
                    this.$bvModal._root.$children[0].modal = {
                        title: 'Cảm ơn bạn đã để lại thông tin',
                        content: 'Đối tác giải ngân sẽ liên hệ hỗ trợ bạn trong thời gian sớm nhất. Gọi số 1900633337 nếu bạn chưa được liên hệ',
                        btnHome: true
                    }
                    this.$bvModal.show('modal-vmain-notify')
                    // this.$bvToast.toast('Đăng ký vay thành công', {
                    //         title: 'Thành công',
                    //         variant: 'success',
                    //         solid: true
                    //     })
                }
            })
        }
       },
       created() {
        getTimaType({}).then(res => {
            this.options = res.data
        })
       },
       beforeCreate() {
           if(document.getElementById("no_1")) {
               document.getElementById("no_1").remove();
           }
       },
       head: {
           script: [
               { type: 'text/javascript', src: window.location.origin + router.options.base + '/script/info_ekyc.js'},
               { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=AW-10851243888' ,  async: true,},
           ],
           noscript: [
               {
                   inner: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1361189891010235&ev=PageView&noscript=1"/>'
               }
           ]
       }
   }
   </script>
   
   <style>
   /* ::-webkit-datetime-edit-year-field:not([aria-valuenow]),
   ::-webkit-datetime-edit-month-field:not([aria-valuenow]),
   ::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
       color: transparent;
   } */
   
   input[type=date]:required:invalid::-webkit-datetime-edit {
       color: transparent;
   }
   input[type=date]:focus::-webkit-datetime-edit {
       color: black !important;
   }
   
   /* .mdl-textfield:not(.is-dirty) input::-webkit-datetime-edit {
        color: transparent; 
   }
   
   input:focus::-webkit-datetime-edit {
       color: rgba(255, 255, 255, .46) !important; 
   } */
   </style>